import { ComponentAPI } from '@philips-emr/tws-core';

type Value = string | number | boolean | unknown;

export interface Data {
  [key: string]: Value;
}

export interface Tuple {
  [key: string]: string;
}

interface MapperFunction {
  (data: Data): Value;
}

class MapperAPI extends ComponentAPI {

  getData(): Data {
    return this.state.data;
  }

  setData(data: Data): void {
    this.setState({ data });
  }

  getMapper(): Tuple {
    return this.state.mapper;
  }

  setMapper(mapper: Tuple): void {
    this.setState({ mapper });
  }

  /**
   * Add a custom mapping, it uses the function to generate the value that will be stored as *name* param.
   * 
   * @param name the name of the property.
   * @param mapper the **pure function** that generates the value.
   */
  addCustomMapping(name: string, mapper: MapperFunction): void {
    const customMapping = { ...this.state.customMapping, [name]: mapper };
    this.setState({ customMapping });
  }

  removeCustomMapping(name: string): void {
    const customMapping = { ...this.state.customMapping };
    delete customMapping[name];
    this.setState({ customMapping });
  }

}

export default MapperAPI;
